// extracted by mini-css-extract-plugin
module.exports = {"container":"checkoutContent_container__3mrIs","mainText":"checkoutContent_mainText__2vCWV","secondaryText":"checkoutContent_secondaryText__gZFPH"};